import React, { useEffect, useState } from "react";
import AllDataCard from "./AllDataCard.js";
import Card from "./Card.js";
import foxLogo from "./foxlogo.png";
import { Link } from "react-router-dom";
import Tooltip from "./Layouts/Tooltip";

const AllData = () => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch user data from your server
    fetch(`${process.env.REACT_APP_BACKEND}/account/all`)
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        setLoading(false);
      });
  }, []);

  // Function to delete user
  const deleteUser = (userId) => {
    fetch(`${process.env.REACT_APP_BACKEND}/account/delete/${userId}`, {
      method: "DELETE",
    })
      .then((response) => {
        if (response.ok) {
          setUserData(userData.filter((user) => user._id !== userId));
        } else {
          throw new Error("Failed to delete the user.");
        }
      })
      .catch((error) => {
        console.error("Deletion error:", error);
      });
  };

  const customStyle = {
    color: "rgb(72, 31, 42)",
    backgroundColor: "rgb(245, 239, 227)",
  };

  const gridStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: "10px",
    gridTemplateRows: "auto",
    borderBottom: "3px solid #000",
  };

  if (loading) {
    return (
      <div>
        <p>Loading user data...</p>
      </div>
    );
  }

  if (userData.length === 0) {
    const noData = {
      color: "rgb(72, 31, 42)",
      backgroundColor: "rgb(245, 239, 227)",
    };
    return (
      <Card customStyle={noData} header="AllData">
        <h2 style={{ color: "rgb(1, 1, 77)" }}>No User Data Available</h2>
        <h4>Please Login</h4>
        <Tooltip text="Home">
          <Link
            to="/"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <img
              src={foxLogo}
              alt="home icon"
              style={{
                width: "20em",
                height: "11em",
                borderRadius: "10px",
              }}
            />
          </Link>
        </Tooltip>
      </Card>
    );
  }

  return (
    <AllDataCard
      customStyle={customStyle}
      className="custom-large-card"
      header="Admin Panel - All Data"
      body={
        <>
          <h1 className="allDataDisplay">
            <span className="foxbank-title">FoxBank</span> User Data
          </h1>
          <div className="user-info-container">
            <div className="user-info-row" style={gridStyles}>
              <p className="category category-name">Name</p>
              <p className="category category-email">Email</p>
              <p className="category category-password">Password</p>
              <p className="category category-action">Action</p>{" "}
              {/* New category for actions */}
            </div>
            {userData.map((currentUser, index) => (
              <div
                key={index}
                className="user-info-row p-user-info"
                style={gridStyles}
              >
                <p>{currentUser.name}</p>
                <p>{currentUser.email}</p>
                <p>{currentUser.password}</p>
                <button onClick={() => deleteUser(currentUser._id)}>
                  Delete
                </button>{" "}
              </div>
            ))}
          </div>
        </>
      }
    />
  );
};

export default AllData;
